
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, MenuItem, TextField } from "@mui/material";
import { useGalponesXGranja, useLoteXID } from "../../../../hooks";
import { generoPollo } from "../../../../data";
import { startSavingDistribucion } from "../../../../services";

import Swal from "sweetalert2";





export const FormDistribucionPollos = ({ sexo }) => {

    const { id } = useParams();
    const { loteXIDQuery } = useLoteXID(`${id}`);
    const { galponesXGranjaQuery } = useGalponesXGranja(loteXIDQuery?.data?.granja._id);


    const [formPedido, setFormPedido] = useState({ genero:'', cantidad: '', galpon: '' });
    const { genero, cantidad, galpon } = formPedido;
    const handleInputChange = ({ target }) => {
        setFormPedido({ ...formPedido, [target.name]: target.value })
    }



    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([cantidad].includes('') ){
            return Swal.fire('Error', 'La cantidad es un campo obligatorio', 'error');
        }
        await Swal.fire({
            title: `Crear Distribución`,
            text: `¿Esta seguro de crear esta distribución?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si Crear`
        }).then( async( _ ) => {
            const resp = await startSavingDistribucion({...formPedido, id});
            if(resp){
                setFormPedido({ genero:'', cantidad: '', galpon: '' }); 
            }
        });
    }



    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>

                {/* <Grid item xs={12}>
                    <TextField required
                        // disabled={true}
                        label='Genero'
                        type='Text'
                        placeholder='Genero'
                        fullWidth
                        name='genero'
                        value={ genero }
                        onChange={ handleInputChange }
                    />
                </Grid> */}

                <Grid item xs={12}>
                    <TextField required
                        select
                        label="Seleccione Genero"
                        fullWidth
                        name='genero'
                        value={ genero }
                        onChange={ handleInputChange }
                    > 
                        <MenuItem value=''>Seleccione Genero</MenuItem>
                        {generoPollo.map( item => (
                            <MenuItem key={item} value={item}>{item}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <TextField required
                        label='Cantidad'
                        type='Number'
                        placeholder='Cantidad'
                        fullWidth
                        name='cantidad'
                        value={ cantidad }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField required select
                        label="Selecione Galpon"
                        fullWidth
                        value={galpon}
                        name='galpon'
                        onChange={ handleInputChange }
                    >
                        <MenuItem value=''>Selecione Galpon</MenuItem>
                        {Array.isArray(galponesXGranjaQuery?.data) && galponesXGranjaQuery?.data.length > 0 ? (
                            galponesXGranjaQuery?.data.map((g) => (
                                <MenuItem key={g.id} value={g.id}> {g.nombre} </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay galpones disponibles</MenuItem>
                        )}
                    </TextField>
                </Grid>
                

            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        Distribuir
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
